import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, observable, throwError, of, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import {
  CURRENT_ENVIROMENT, SERVICE_END_POINT,
  CurrencyFunctionalityService, FundsFunctionalityService, DealPartnerFunctionalityService, StartQuoteService
} from '../../../shared';
import * as StoreModel from '../../../model/ngrx';
import { AppState } from '../../../store/state/app.state';
import { ElementsConfig } from '../../../pages/user-details/config/user-data.config';
import * as UserDataConfig from '../../../common-components/config/user-data.config';
import * as resDataCaptureActions from '../../../store/actions/response-quote-datacapture.actions';
import * as resDataCalculationActions from '../../../store/actions/response-quote-calculation.actions';
import * as quoteResultActions from '../../../store/actions/quote-result.actions';
import * as loggedInDetailActions from '../../../store/actions/loggedin-detail.action';
import * as PersDetailsActions from '../../../store/actions/personal-details.actions';
import * as LifeStyleActions from '../../../pages/medical-underwriting/store/actions/lifestyle.action';
import * as MedicalConditionActions from 'src/app/pages/medical-underwriting/store/actions/medicalCondition.action';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { catchError } from 'rxjs/operators';
// import { NullTemplateVisitor } from '@angular/compiler';
import { EventEmitter } from '@angular/core';
import { UnderWritingData, RiskWarningModel } from 'src/app/pages/medical-underwriting/model/lifestyle.post.model';
import { UtilService } from './util.service';
import * as RefNoActions from '../../../store/actions/reference-number.actions';
import { filter } from 'rxjs/operators';
import { FundsModelFunctionalityService } from 'src/app/shared/utilities/functionality/funds-model-functionality-service';
import { UIRulesRequest, Attribute } from 'src/app/model/uiRules-request.model';
import { ATTRIBUTE_NAME_ID } from 'src/app/pages/user-details/config/ceding-fund-attribute-id';
import { Attributes, ComponentTypes } from 'src/app/model/ui-rule-response-model';
import { UiRuleReqPayload, AttributeReqPayLoad, ComponentAttributes } from 'src/app/model/ui-rule-request-payload';
import { ATTRIBUTE_NAMES_CONST } from 'src/app/shared/services/api-constants/attribute-names-constant';
import { DatePipe } from '@angular/common';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { RefNo } from 'src/app/model/ngrx';
import { AuthLibService } from '@landg_eap/auth-lib';



const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
const transferTypeValueEnum = {
  landgOOS: 'landgOOS',
  landg: 'landg',
  IV: 'IV',
  externalOMO: 'externalOMO',
  externaIVPP: 'externalIVPP'

}


@Injectable({
  providedIn: 'root'
})
export class QuoteDataCaptureService {

  quoteDataCapture: any;
  invokeLoginFunction = new EventEmitter();
  invokeLogoutFunction = new EventEmitter();
  subsVar: Subscription;
  invokeSaveFunction = new EventEmitter();

  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

  beforeStartDetail: StoreModel.BeforeStart;
  beforeStartDetailStore: Observable<StoreModel.BeforeStart[]>;

  personDetail: StoreModel.PersonalDetails;
  personalDetailsStore: Observable<StoreModel.PersonalDetails[]>;

  guidanceAndAdviceDetail: StoreModel.GuidanceAndAdvice;
  guidanceAndAdviceDetailStore: Observable<StoreModel.GuidanceAndAdvice[]>;

  registrationDetails: StoreModel.RegistrationDetails;
  registrationDetailsStore: Observable<StoreModel.RegistrationDetails[]>;

  loginDetails: any[];
  loginDetailsStore: Observable<any[]>;

  dependentDetail: StoreModel.DependantDetails;
  dependentDetailStore: Observable<StoreModel.DependantDetails[]>;

  playbackDetail: StoreModel.QuotePlaybackRiskWarning;
  playbackDetailStore: Observable<StoreModel.QuotePlaybackRiskWarning[]>;

  public fundDetails: StoreModel.YourPension;
  private fundDetailsStore: Observable<StoreModel.YourPension[]>;

  private responseDataCapture: any[];
  private responseDataCaptureStore: Observable<any[]>;

  private sourcesList = ElementsConfig.sourcesListCvt;
  private fundAttributesList = ElementsConfig.fundAttributes;

  public requestQuoteCalculation: any[];
  private requestQuoteCalculationStore: Observable<any[]>;

  public responseQuoteCalculation: any[];
  private responseQuoteCalculationStore: Observable<any[]>;

  productChoice: StoreModel.ProductChoice;
  productChoiceStore: Observable<StoreModel.ProductChoice[]>;

  underWritingData: UnderWritingData;
  private lifeStyleStore: Observable<UnderWritingData>;

  medicalConditionData: any[];
  private medicalConditionDataStore: Observable<any[]>;

  ACECalCounter: number;

  quoteRefNo = '';
  formSessionId = '';
  isValidated: boolean;
  quoteRefNoStore: Observable<RefNo[]>;
  screenName = '';
  productCodeValue = '';
  underwritingLifeValue = 'A';
  _isBackButtonClick = true;
  lifeStyleRiskWarningObject: RiskWarningModel;
  PolicyNumber = '';
  requoteFlag: false;
  referenceNumber: RefNo;
  constructor(private http: HttpClient, private router: Router,
    private store: Store<AppState>,
    private utilService: UtilService,
    private startQuoteService: StartQuoteService,
    private fundsModelFunctionalityService: FundsModelFunctionalityService,
    public datePipe: DatePipe, private authLibService: AuthLibService
  ) {
    this.beforeStartDetailStore = this.store.select(STORE_VAL.before_start);
    this.personalDetailsStore = this.store.select(STORE_VAL.personal_details);
    this.registrationDetailsStore = this.store.select(STORE_VAL.registration_details);
    this.dependentDetailStore = this.store.select(STORE_VAL.dependant_details);
    this.fundDetailsStore = this.store.select(STORE_VAL.your_pension);
    this.responseDataCaptureStore = this.store.select(STORE_VAL.quote_capture);
    this.quoteRefNoStore = this.store.select(STORE_VAL.ref_no);
    this.productChoiceStore = this.store.select(STORE_VAL.product_choice);
    this.requestQuoteCalculationStore = this.store.select(STORE_VAL.req_quote_calculation);
    this.responseQuoteCalculationStore = this.store.select(STORE_VAL.quote_calculation);
    this.lifeStyleStore = this.store.select(STORE_VAL.lifestyle);
    this.medicalConditionDataStore = this.store.select(STORE_VAL.medical_conditon);
    this.guidanceAndAdviceDetailStore = this.store.select(STORE_VAL.guidance_and_advice);
    this.quoteRefNoStore.subscribe((val) => {
      if (val.length > 0) {
        // this.referenceNumber = val[0];
        this.quoteRefNo = val[0]?.quoteReferenceNumber;
        this.formSessionId = val[0]['formSessionId'];
        this.isValidated = val[0]['isValidated'];
      }
    });

    this.beforeStartDetailStore.subscribe((val) => {
      if (val.length > 0) {
        this.beforeStartDetail = val[0];
      }
    });

    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.personDetail = val[0];
      }
    });

    this.registrationDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.registrationDetails = val[0];
      }
    });

    this.loginDetailsStore = this.store.select(STORE_VAL.loggedin_detail);
    this.loginDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.loginDetails = val[0];
      }
    });

    this.dependentDetailStore.subscribe((val) => {
      if (val.length > 0) {
        this.dependentDetail = val[0];
      }
    });

    this.playbackDetailStore = this.store.select(STORE_VAL.quote_playback_risk_warning);
    this.playbackDetailStore.subscribe((val) => {
      if (val.length > 0) {
        this.playbackDetail = val[0];
      }
    });

    this.fundDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.fundDetails = val[0];
      }
    });

    this.responseDataCaptureStore.subscribe((val) => {
      if (val.length > 0) {
        this.responseDataCapture = val[0];
        if (this.responseDataCapture && this.responseDataCapture['fundModel'] && this.responseDataCapture['fundModel'].length > 0) {
          this.PolicyNumber = this.responseDataCapture['fundModel'][0]['policyNo']
        }
      }
    });

    this.productChoiceStore.subscribe((val) => {
      if (val.length > 0) {
        this.productChoice = val[0];
      }
    });

    this.requestQuoteCalculationStore.subscribe((val) => {
      if (!this.checkIfObjEmpty(val) && val.length > 0) {
        this.requestQuoteCalculation = val[0];
      } else if (val?.length === 0) {
        this.requestQuoteCalculation = undefined;
      }
    });

    this.responseQuoteCalculationStore.subscribe((val) => {
      if (val.length > 0) {
        this.responseQuoteCalculation = val[0];
      } else if (val.length === 0) {
        this.responseQuoteCalculation = undefined;
      }
    });

    // underwriting
    this.lifeStyleStore.subscribe((val) => {
      if (val[0]) {
        this.lifeStyleRiskWarningObject = val[0].riskAndStaticQuestion;
        this.underWritingData = JSON.parse(JSON.stringify(val[0]));
        delete this.underWritingData.riskAndStaticQuestion;
      }
    });

    this.guidanceAndAdviceDetailStore.subscribe((val) => {
      if (val.length > 0) {
        this.guidanceAndAdviceDetail = val[0];
      }
    });

    this.medicalConditionDataStore.subscribe(val => {
      if (val) {
        this.medicalConditionData = val[0];
      }
    });
  }
  getBackClicked() {
    return this._isBackButtonClick;
  }
  setBackClicked(value: boolean) {
    this._isBackButtonClick = value;
  }
  public getScreenName() {
    let breadcrumbDetails = UserDataConfig.BreadcrumbConfig.data.values;
    const currentArray = breadcrumbDetails.filter((arr, index) => {
      return arr.path === this.router.url.split('?')[0];
    });
    if (currentArray[0].screenName !== 'registration' && currentArray[0].screenName !== 'update-my-details') {
      this.screenName = currentArray[0].screenName;
    }

  }
  processHOUnderwriting(): any {
    let data = {};
    if (this.responseDataCapture) {
      data = this.responseDataCapture

    }
    /* data['underwritingData'] = this.underWritingData;
    data['triggeredBy'] = 'HOuser'; */
    data = {...data, underwritingData: this.underWritingData, triggeredBy: 'HOuser'};
    return data;
  }

  postQuoteDataCapture(isValidationRequired: boolean = true): Observable<any> {
    let hoData;
    if (this.router.url.includes('ho-underwriting')) {
      hoData = this.processHOUnderwriting()
    } else {
      this.quoteDataCapture = this.quoteDataCaptureStructure();
      this.getScreenName();
      this.processQuoteInformation(isValidationRequired, null);
    }
    if (this.quoteDataCapture && this.quoteDataCapture.benefitVariants && this.quoteDataCapture.benefitVariants.length > 0) {
      this.quoteDataCapture.benefitVariants.forEach(val => {
        if (val.selected == true) {
          this.quoteDataCapture.benefitBasis = val['benefitBasisModel'];
        }
      });
    }
    ////console.log(JSON.stringify(this.quoteDataCapture.underwritingData.annuitantMedicalConditions[0].questions));
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.saveQuoteDataCapture).pipe(
        map((res: Response) => {
          if (this.router.url.includes('ho-underwriting')) {
            res['lock'] = false;
          }
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
          this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
          return res;
        }),
        filter(res => res['lock'] !== true)
      );

    } else {
      return this.http.post<any>(this.endPoints.saveQuoteDataCapture, hoData ? hoData : this.quoteDataCapture, httpOptions).pipe(
        map((res: Response) => {
          if (this.router.url.includes('ho-underwriting')) {
            res['lock'] = false;
          }
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
          this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
          this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
      );

    }
  }

  updateRegisteredDetailsDataCapture(isValidationRequired: boolean = true): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    this.getScreenName();
    this.processQuoteInformation(isValidationRequired, null);
    //console.log("values from backend call", JSON.stringify(this.quoteDataCapture));
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.updateRegistrationDataCapture).map((res: Response) => {
        this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
        this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
        //console.log("response for registration", res);
        return res;
      });
    } else {
      //console.log(this.endPoints.saveQuoteDataCapture);
      return this.http.post<any>(this.endPoints.updateRegistrationDataCapture, this.quoteDataCapture.customer, httpOptions).
        map((res: Response) => {
          // this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
          // this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
          return res;
        }
        );
    }
  }
  postRegistrationDataCapture(isValidationRequired: boolean = true): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    this.getScreenName();
    this.processQuoteInformation(isValidationRequired, null);

    if(this.quoteDataCapture && this.quoteDataCapture.customer) {
      this.quoteDataCapture.customer.partyId = "";
    }
    //console.log("values from backend call", JSON.stringify(this.quoteDataCapture));
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.registrationDataCapture).map((res: Response) => {
        this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
        this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
        //console.log("response for registration", res);
        return res;
      });
    } else {
      //console.log(this.endPoints.saveQuoteDataCapture);
      return this.http.post<any>(this.endPoints.registrationDataCapture, this.quoteDataCapture, httpOptions).
        map((res: Response) => {
          this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
          this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
          return res;
        }
        );
    }
  }

  postRefreshCard(): Observable<any> {
    let quoteRef = { 'requestId': this.quoteRefNo };

    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.refreshCardUrl).map((res: Response) => {

        this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
        this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));

        return res;
      });
    } else {
      return this.http.post<any>(this.endPoints.refreshCardUrl, quoteRef, httpOptions).
        map((res: Response) => {
          /*  this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
           this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res)); */
          this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
          return res;
        }
        );
    }
  }

  processQuoteInformation(isValidationRequired, index) {

    this.quoteDataCapture.validate = isValidationRequired;
    this.quoteDataCapture.currentScreen = this.screenName;
    this.quoteDataCapture.quoteRefNo = this.quoteRefNo;
    this.quoteDataCapture.isValidated = this.isValidated ? this.isValidated : false;
    this.quoteDataCapture.formSessionId = this.formSessionId;
    this.quoteDataCapture.cameFromMicrosite = this.fundDetails && this.fundDetails.cameFromMicrosite || false;



    this.quoteDataCapture.customer = this.processCustomerInformation(this.quoteDataCapture.customer, this.personDetail, this.registrationDetails, this.loginDetails);

    // tslint:disable-next-line:max-line-length
    this.quoteDataCapture.secondLife = (this.dependentDetail && this.dependentDetail.dependantQuestion === 'Y' && this.productChoice.selectedProduct === 'C') ? this.processDependentInformation(this.quoteDataCapture.secondLife, this.dependentDetail) : null;

    if (this.fundDetails) {
      if (this.fundDetails['productCodes'] && this.fundDetails['productCodes'].length > 0) {
        this.quoteDataCapture.dealPartnerProductModel.productCodeModels = this.fundDetails['productCodes'];
        this.productCodeValue = this.fundDetails['productCodes'][0]['productCode'];
      } else if (DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(this.fundDetails.fundProvider)) {
        let productCodeObjArray = [];
        productCodeObjArray.push(this.createDefaultProductCodeModelObject());
        this.quoteDataCapture.dealPartnerProductModel.productCodeModels = productCodeObjArray;
      }
    }
    this.quoteDataCapture.fundValidateInd = this.fundDetails && this.fundDetails['fundValidateInd'] ? this.fundDetails.fundValidateInd : false;
    if (this.fundDetails && this.fundDetails['benefitTypes'] && this.fundDetails['benefitTypes'].length > 0) {
      this.quoteDataCapture.dealPartnerProductModel.benefitTypes = this.fundDetails['benefitTypes'];
    }

    if (this.fundDetails && this.fundDetails['productTypes'] && this.fundDetails['productTypes'].length > 0) {
      this.quoteDataCapture.dealPartnerProductModel.productList = this.fundDetails['productTypes'];
    }

    this.quoteDataCapture.sourceforDCJ = this.fundDetails && this.fundDetails['manualSource'] ? this.fundDetails['manualSource'] : '';
    this.quoteDataCapture.source = this.fundDetails && this.fundDetails['fundProvider'];
    this.quoteDataCapture.dealPartnerProductModel.dealpartnerCode = this.fundDetails && this.fundDetails['fundProvider'];
    this.quoteDataCapture.quoteBasis = this.processQuoteBasisInformation();
    let benefitBasisArray = [];
    benefitBasisArray.push(this.processBenefitBasisInformation());
    this.quoteDataCapture.benefitBasis = benefitBasisArray;

    if (index) {
      this.quoteDataCapture.benefitBasis[0].quickQuoteIdentifier = index;
    }

    this.quoteDataCapture.benefitBasis[0].pensionFund = this.fundDetails ? this.fundDetails.totalSum : 0;
    if (this.responseQuoteCalculation && this.responseQuoteCalculation['benefitVariants']) {
      // tslint:disable-next-line:max-line-length
      this.quoteDataCapture.benefitVariants = this.responseQuoteCalculation['benefitVariants'].length > 0 ? this.responseQuoteCalculation['benefitVariants'] : [];
      //console.log("checking benefit varient", this.quoteDataCapture.benefitVariants);
    }

    if (this.quoteDataCapture && this.quoteDataCapture.benefitVariants && this.quoteDataCapture.benefitVariants.length > 0 && this.screenName == 'quote-playback') {
      this.quoteDataCapture.benefitVariants.forEach(val => {
        if (val.selected == true) {
          this.quoteDataCapture.benefitBasis = val['benefitBasisModel'];
          this.quoteDataCapture.quoteBasis = val['quoteBasisModel'];
        }
      });
    }

    if (!!this.quoteDataCapture.source && this.quoteDataCapture.benefitBasis && this.quoteDataCapture.benefitBasis.length > 0) {
      this.quoteDataCapture.fundModel =
       this.fundsModelFunctionalityService.createFundModel(this.quoteDataCapture.source, this.quoteDataCapture.benefitBasis[0]);
    }

    // related to Guidance And Advice
    if (this.guidanceAndAdviceDetail && this.guidanceAndAdviceDetail.riskAndStaticQuestion) {
      this.guidanceAndAdviceDetail.riskAndStaticQuestion.forEach(q => {
        this.quoteDataCapture.riskAndStaticQuestion.push(q);
      });
    }

    // related to Before You Start
    if (this.beforeStartDetail && this.beforeStartDetail.riskAndStaticQuestion) {
      this.beforeStartDetail.riskAndStaticQuestion.forEach(q => {
        this.quoteDataCapture.riskAndStaticQuestion.push(q);
      });
    }
    // related to Your Pension Saving
    if (this.fundDetails && this.fundDetails.riskAndStaticQuestion) {
      if (this.fundDetails.riskAndStaticQuestion && this.fundDetails.riskAndStaticQuestion.length > 0) {
        this.fundDetails.riskAndStaticQuestion.forEach(q => {
          this.quoteDataCapture.riskAndStaticQuestion.push(q);
        });
      }

    }
    // related to Product Choice
    if (this.productChoice && this.productChoice.riskAndStaticQuestion) {
      this.productChoice.riskAndStaticQuestion.forEach(q => {
        this.quoteDataCapture.riskAndStaticQuestion.push(q);
      });
    }
    // related to Dependant Details
    if (this.dependentDetail && this.dependentDetail.riskAndStaticQuestion) {
      this.dependentDetail.riskAndStaticQuestion.forEach(q => {
        this.quoteDataCapture.riskAndStaticQuestion.push(q);
      });
    }
    if (this.productChoice) {
      this.quoteDataCapture.product = this.productChoice.selectedProduct;
      // this.quoteDataCapture.source = this.productChoice.source;
      this.quoteDataCapture.productOptions = this.productChoice.productOptions;
    }
    // UNDERWRITING
    // UNDERWRITING
    if (this.productChoice && this.productChoice.selectedProduct === 'C' && this.underWritingData) {
      this.quoteDataCapture.underwritingData = this.underWritingData;
      this.underwritingLifeValue = (this.underWritingData && this.underWritingData['dependentMedicalConditions'] && this.underWritingData['dependentMedicalConditions'].length > 0) ? 'S' : 'A';
    }

    // lifestyle Risk Warning Question
    if (this.lifeStyleRiskWarningObject) {
      this.quoteDataCapture.riskAndStaticQuestion.push(this.lifeStyleRiskWarningObject);
    }

    if (this.productChoice && this.productChoice.selectedProduct === 'C' && this.fundDetails) {
      // tslint:disable-next-line: max-line-length
      this.quoteDataCapture.underwriting.netAmount = (this.quoteDataCapture && this.quoteDataCapture.benefitBasis.netPensionFund) ? this.quoteDataCapture && this.quoteDataCapture.benefitBasis.netPensionFund : this.fundDetails.totalSum;
    }
    //playback risk questions
    if (this.playbackDetail) {
      if (this.playbackDetail.riskAndStaticQuestion) {
        this.playbackDetail.riskAndStaticQuestion.forEach(q => {
          this.quoteDataCapture.riskAndStaticQuestion.push(q);
        });
      }
    }
    // new logic - for omni channel scenarios
    let riskAndStaticCount;
    if (!this.checkIfValueIsEmpty(this.guidanceAndAdviceDetail)
      || !this.checkIfValueIsEmpty(this.quoteDataCapture.product)) {
      riskAndStaticCount = this.getRiskAndStaticQuestionCount(this.guidanceAndAdviceDetail.riskAndStaticQuestion,
        this.quoteDataCapture.product);
    }
    this.quoteDataCapture.riskFormCompleted = !this.checkIfValueIsEmpty(this.quoteDataCapture.product)
      && (riskAndStaticCount && riskAndStaticCount === this.quoteDataCapture.riskAndStaticQuestion.length) ? true : false;
    if (this.responseQuoteCalculation) {
      if (this.responseQuoteCalculation['aceCalCounter']) {
        this.quoteDataCapture.aceCalCounter = this.responseQuoteCalculation['aceCalCounter'];
      }
    }
    //console.log(this.quoteDataCapture);
  }
  checkIfValueIsEmpty(val) {
    if (val === undefined || val === null || val === '') {
      return true;
    }
    return false;
  }
  checkIfObjEmpty(obj) {
    if (!this.checkIfValueIsEmpty(obj) && Object.keys(obj).length > 0) {
      return false;
    } return true;
  }
  /* returns the total No of risk&Static Questions throughout the application */
  getRiskAndStaticQuestionCount(guidanceAndAdviceScreenData: any, product: string) {
    let count = 0;
    if (guidanceAndAdviceScreenData && guidanceAndAdviceScreenData.length > 0) {
      guidanceAndAdviceScreenData.forEach(question => {
        if (question.questionCode === 'bookPensionWiseAppointmentQuestion' && !this.checkIfValueIsEmpty(question.answer)) {
          if (question.answer === 'AA' || question.answer === 'AB') {
            count = 2;
          } else {
            count = 1;
          }
        }
      })
    }
    if (product === 'C') {
      count = count + 13; // including dependant question
    } else if (product === 'H' || product === 'G') {
      count = count + 13;
    }
    return count;
  }
  processQuoteBasisInformation() {
    // const data = this.quoteDataCapture.quoteBasis;
    // data.quoteType = 'IVPP';
    // return data;
    let data;
    let quotetype = 'OMO';
    // tslint:disable-next-line: max-line-length
    let calculatedTaxFreeLumSum = this.requestQuoteCalculation && this.requestQuoteCalculation['calculatedTaxFreeLumSum'] ? this.requestQuoteCalculation['calculatedTaxFreeLumSum'] : null
    if ((this.fundDetails && this.fundDetails.fundProvider === 'I') && (this.productChoice && this.productChoice.selectedProduct === 'C')) {
      if (this.fundDetails.external.fundValue && Number(this.fundDetails.external.fundValue.toString().replace(/,/g, '')) > 0) {
        quotetype = 'InternalOMO';

      } else {
        quotetype = 'INTERNAL';

      }

    } else {
      quotetype = (this.productChoice && this.productChoice.selectedProduct !== 'C' && this.productChoice.selectedProduct !== '') ? 'IVPP' : 'OMO';
      // tslint:disable-next-line: max-line-length
      /*
      if (this.fundDetails && this.fundDetails.fundProvider === 'B' && this.productChoice && this.productChoice.selectedProduct && this.productChoice.selectedProduct !== 'C' && (calculatedTaxFreeLumSum && calculatedTaxFreeLumSum[0] && calculatedTaxFreeLumSum[0].value && calculatedTaxFreeLumSum[0].value > 0)) {
        quotetype = 'IVPP';
      } else if (this.fundDetails && this.fundDetails.fundProvider === 'B') {
        quotetype = 'OMO';
      }
      */
    }

    if (this.requestQuoteCalculation && (this.requestQuoteCalculation['productType'] === 'C')) {
      data = {
        //quoteType: 'INTERNAL',
        quoteType: quotetype,
        // tslint:disable-next-line: max-line-length
        commencementDate: this.requestQuoteCalculation['startDate'] ? this.requestQuoteCalculation['startDate'].toString().replace(/ /g, '') : null,
        startDateType: this.requestQuoteCalculation['currentDate'] === 'A' ? 'As Soon As Possible' : null,
        paymentFrequency: this.requestQuoteCalculation['frequency'],
        paymentAdvance: this.requestQuoteCalculation['advance'],
        policyTerm: null,
        policyTermMonths: 0,
        selectedRetirementDate: null,
        cedingPolicyNos: '',
        quoteRateDate: null,
        currentRate: 'Y',
        productCode: this.productCodeValue,
        dealPartnerPolicyStrtDt: null,
        guaranteedAnnuityRate: 'N',
        earlyRetirement: 'N',
        profitAdjustmentInd: 'N',
        profitAdjustmentPercentage: null,
        requoteCurrentRateFlag: 'N',
        fundingType: 'OP',
        customerNeed: 'RT',
        rateGuaranteeQuoteInd: 'N',
        invalid: false
      };
    } else if (this.requestQuoteCalculation && (this.requestQuoteCalculation['productType'] === 'H')) {
      data = {
        //quoteType: 'IVPP',
        quoteType: quotetype,
        // tslint:disable-next-line: max-line-length
        commencementDate: this.requestQuoteCalculation['startDate'] ? this.requestQuoteCalculation['startDate'].toString().replace(/ /g, '') : null,
        startDateType: this.requestQuoteCalculation['currentDate'] === 'A' ? 'As Soon As Possible' : null,
        // tslint:disable-next-line:max-line-length
        paymentFrequency: (this.requestQuoteCalculation['fundValue'] && parseInt(this.requestQuoteCalculation['fundValue']) === 0) ? 'M' : this.requestQuoteCalculation['frequency'],
        // tslint:disable-next-line:max-line-length
        paymentAdvance: (this.requestQuoteCalculation['fundValue'] && parseInt(this.requestQuoteCalculation['fundValue']) === 0) ? 'A' : this.requestQuoteCalculation['advance'],
        policyTerm: this.requestQuoteCalculation['termplan'],
        policyTermMonths: this.requestQuoteCalculation['termmonth'],
        selectedRetirementDate: null,
        cedingPolicyNos: '',
        quoteRateDate: null,
        currentRate: 'Y',
        productCode: this.productCodeValue,
        dealPartnerPolicyStrtDt: null,
        guaranteedAnnuityRate: 'N',
        earlyRetirement: 'N',
        profitAdjustmentInd: 'N',
        profitAdjustmentPercentage: null,
        requoteCurrentRateFlag: 'N',
        fundingType: 'OP',
        customerNeed: 'RT',
        rateGuaranteeQuoteInd: 'N',
        invalid: false
      };
    } else if (this.requestQuoteCalculation && (this.requestQuoteCalculation['productType'] === 'G')) {
      data = {
        //quoteType: 'INTERNAL',
        quoteType: this.requestQuoteCalculation['selectedQuoteType'] ? this.requestQuoteCalculation['selectedQuoteType']
          : (this.responseQuoteCalculation && this.responseQuoteCalculation['quoteBasis']
            ? this.responseQuoteCalculation['quoteBasis']['quoteType'] : null),
        // tslint:disable-next-line: max-line-length
        commencementDate: this.requestQuoteCalculation['startDate'] ? this.requestQuoteCalculation['startDate'].toString().replace(/ /g, '') : null,
        startDateType: this.requestQuoteCalculation['currentDate'] === 'A' ? 'As Soon As Possible' : null,
        paymentFrequency: this.requestQuoteCalculation['frequency'],
        paymentAdvance: this.requestQuoteCalculation['advance'],
        policyTerm: this.requestQuoteCalculation['termyear'],
        policyTermMonths: this.requestQuoteCalculation['termmonth'],
        selectedRetirementDate: null,
        cedingPolicyNos: '',
        quoteRateDate: null,
        currentRate: 'Y',
        productCode: this.productCodeValue,
        dealPartnerPolicyStrtDt: null,
        guaranteedAnnuityRate: 'N',
        earlyRetirement: 'N',
        profitAdjustmentInd: 'N',
        profitAdjustmentPercentage: null,
        requoteCurrentRateFlag: 'N',
        fundingType: 'OP',
        customerNeed: 'RT',
        rateGuaranteeQuoteInd: 'N',
        invalid: false
      };
    }
    else {
      data = {
        //quoteType: 'INTERNAL',
        quoteType: quotetype,
        commencementDate: null,
        startDateType: null,
        paymentFrequency: '',
        paymentAdvance: '',
        policyTerm: null,
        policyTermMonths: 0,
        selectedRetirementDate: null,
        cedingPolicyNos: '',
        quoteRateDate: null,
        currentRate: 'Y',
        productCode: this.productCodeValue,
        dealPartnerPolicyStrtDt: null,
        guaranteedAnnuityRate: 'N',
        earlyRetirement: 'N',
        profitAdjustmentInd: 'N',
        profitAdjustmentPercentage: null,
        requoteCurrentRateFlag: 'N',
        fundingType: 'OP',
        customerNeed: 'RT',
        rateGuaranteeQuoteInd: 'N',
        invalid: false
      };
    }

    return data;
  }
  processBenefitBasisInformation() {
    let data;
    // fundDetails.filter( f => f.transferType !== 'Tfc').map(item => item.fundValue).reduce((prev, next) => prev + next)
    let totalSum1 = (this.fundDetails ? this.fundDetails.cedingFund : 0) + (this.fundDetails ? this.fundDetails.external.fundValue : 0);
    let multipleTaxfree = (this.requestQuoteCalculation && this.requestQuoteCalculation['calculatedTaxFreeLumSum'] &&
      this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 1) ? true : false;
    let fundProvider = (this.fundDetails && this.fundDetails.fundProvider) ?
      this.fundDetails.fundProvider : null;
    let taxFreeTotal = (this.requestQuoteCalculation && this.requestQuoteCalculation['calculatedTaxFreeLumSum']
      && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
      ((this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 1) ?
        this.requestQuoteCalculation['calculatedTaxFreeLumSum'].reduce((taxFree1, taxFree2) => {
          return (taxFree1.value + taxFree2.value);
        }) : this.requestQuoteCalculation['calculatedTaxFreeLumSum'][0].value) : 0;
    taxFreeTotal = taxFreeTotal ? taxFreeTotal : 0;
    let netFund = null;
    let extFund = null;
    if (this.fundDetails) {
      netFund = (this.fundDetails.totalSum - taxFreeTotal).toFixed(2);
    }
    if (this.fundDetails && this.fundDetails.external) {
      extFund = this.fundDetails.external.fundValue ?
        CurrencyFunctionalityService.convertCurrencyToNumber((this.fundDetails.external.fundValue).toString()).toFixed(2) : null;
    }
    if (this.requestQuoteCalculation && (this.requestQuoteCalculation['productType'] === 'C')) {
      data = {
        benefitType: 'N1',
        targeted: null,
        annualIncome: null,
        maturityAmount: null,
        cedingFundAmount: (this.fundDetails && fundProvider !== 'B') ? this.fundDetails.cedingFund || null : null,
        externalFundAmount: extFund,
        pre88AnnualIncome: null,
        post88AnnualIncome: null,
        taxFreeCashAmountPercent: (multipleTaxfree || fundProvider !== 'B') ? (this.requestQuoteCalculation['taxfreeRadioButton'] ?
          this.requestQuoteCalculation['taxfreeRadioButton'] : null) : null,
        extTaxFreeCashAmountPercent: (multipleTaxfree || fundProvider === 'B') ?
          (this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] ?
            this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] : null) : null,
        // ((fundProvider === 'B') ?
        //   (this.requestQuoteCalculation['taxfreeRadioButton']) : null),
        taxFreeCashPercentage: (fundProvider !== 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
          // tslint:disable-next-line: max-line-length
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null,

        // tslint:disable-next-line: max-line-length
        extTaxFreeCashPercentage: (multipleTaxfree && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0)
          ?
          // tslint:disable-next-line: max-line-length
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc)
          :
          (fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0)
            ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary') ? this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc : null)
            : null,
        // :
        // ((fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
        //   (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null),
        taxFreeCashAmount: (fundProvider !== 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
          // tslint:disable-next-line: max-line-length
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value) : null,

        extTaxFreeCashAmount: (multipleTaxfree && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0)
          ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value)
          :
          (fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0)
            ?
            // tslint:disable-next-line: max-line-length
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary') ? this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value : null)
            : null,
        // :
        // ((fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
        // (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value) : null),
        netPensionFund: netFund ? netFund : null,
        dateEligibleFrGuarantee: '',
        guaranteeAmt: null,
        proportionIndicator: (this.requestQuoteCalculation['frequency'] === 'Y' &&
          this.requestQuoteCalculation['advance'] === 'B') ? 'Y' : 'N',
        escalationType: (this.requestQuoteCalculation['increasedincome'] === 'F') ?
          this.requestQuoteCalculation['increasedincomeslider'] : this.requestQuoteCalculation['increasedincome'],
        // tslint:disable-next-line:max-line-length
        guaranteedTermIndicator: ((!this.requestQuoteCalculation['periodofincome'] || this.requestQuoteCalculation['periodofincome'] === 0) ? 'N' : 'O'),
        pre88EscalationType: null,
        post88EscalationType: null,
        // tslint:disable-next-line:max-line-length
        escalationRate: (this.requestQuoteCalculation['increasedincome'] === 'F') ? this.requestQuoteCalculation['increasedincomeslider'] : null,
        // tslint:disable-next-line:max-line-length
        guaranteedTerm: this.requestQuoteCalculation['periodofincome'],
        // tslint:disable-next-line:max-line-length
        secondLifePensionPercentage: !this.requestQuoteCalculation['incomepercentage'] ? null : this.requestQuoteCalculation['incomepercentage'],
        // tslint:disable-next-line:max-line-length
        secondLifePensionPercentageType: !this.requestQuoteCalculation['incomepercentage'] ? 'N' : this.requestQuoteCalculation['incomepercentage'],
        pre88SecondLifePensionPercentageType: '',
        post88SecondLifePensionPercentageType: '',
        // tslint:disable-next-line:max-line-length
        secondLifeAnyOrNamed: (isNaN(this.requestQuoteCalculation['incomepercentage']) || !this.requestQuoteCalculation['incomepercentage'] || this.requestQuoteCalculation['incomepercentage'] === 0) ? '' : 'N',
        overlapType: 'N',
        minAgeForGarYears: null,
        minAgeForGarMonths: null,
        maxAgeForGarYears: null,
        maxAgeForGarMonths: null,
        // tslint:disable-next-line:max-line-length
        vpPercentage: (this.requestQuoteCalculation['valueprotection'] === 'Ann') ? this.requestQuoteCalculation['vpslider'] : null,
        vpIndicator: this.requestQuoteCalculation['valueprotection'],
        vpAmount: null,
        vpBasis: (this.requestQuoteCalculation['valueprotection'] === 'Ann') ? 'SL' : null,
        careProviderFee: null,
        totalFund: null,
        monthlyIncome: null,
        quickQuoteIdentifier: 1,
        pensionFund: null
      };
    } else if (this.requestQuoteCalculation && (this.requestQuoteCalculation['productType'] === 'H')) {
      data = {
        benefitType: 'N1',
        targeted: null,
        // tslint:disable-next-line:max-line-length
        annualIncome: ((this.requestQuoteCalculation['incomematurity'] === 'Y') ? CurrencyFunctionalityService.convertCurrencyToNumber(this.requestQuoteCalculation['fundValue']) : null),
        // tslint:disable-next-line:max-line-length
        maturityAmount: ((this.requestQuoteCalculation['incomematurity'] === 'M') ? CurrencyFunctionalityService.convertCurrencyToNumber(this.requestQuoteCalculation['fundValue']) : null),
        cedingFundAmount: (this.fundDetails && this.fundDetails.cedingFund) ? this.fundDetails.cedingFund : null,
        externalFundAmount: extFund,
        pre88AnnualIncome: null,
        post88AnnualIncome: null,
        taxFreeCashAmountPercent: (multipleTaxfree || fundProvider !== 'B') ? (this.requestQuoteCalculation['taxfreeRadioButton'] ?
          this.requestQuoteCalculation['taxfreeRadioButton'] : null) : null,
        extTaxFreeCashAmountPercent: (multipleTaxfree) ?
          (this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] ?
            this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] : null) :
          ((fundProvider === 'B') ?
            (this.requestQuoteCalculation['taxfreeRadioButton']) : null),
        taxFreeCashPercentage: (fundProvider !== 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
          // tslint:disable-next-line: max-line-length
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary' || taxfree.mode === 'secondary').perc) : null,
        extTaxFreeCashPercentage: (multipleTaxfree) ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc)
          :
          ((fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null),
        taxFreeCashAmount: (fundProvider !== 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
          // tslint:disable-next-line: max-line-length
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary' || taxfree.mode === 'secondary').value) : null,
        extTaxFreeCashAmount: (multipleTaxfree) ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value)
          :
          ((fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value) : null),
        netPensionFund: netFund ? netFund : null,
        dateEligibleFrGuarantee: '',
        guaranteeAmt: null,
        proportionIndicator: '',
        escalationType: (this.requestQuoteCalculation['increasedincome'] === 'F') ?
        this.requestQuoteCalculation['increasedincomeslider'] : this.requestQuoteCalculation['increasedincome'],
        // tslint:disable-next-line:max-line-length
        guaranteedTermIndicator: this.requestQuoteCalculation['periodofincomequestion'],
        pre88EscalationType: null,
        post88EscalationType: null,
        escalationRate:  (this.requestQuoteCalculation['increasedincome'] === 'F') ? this.requestQuoteCalculation['increasedincomeslider'] : null,
        // tslint:disable-next-line:max-line-length
        guaranteedTerm: (this.requestQuoteCalculation['periodofincomequestion'] === 'O' ? this.requestQuoteCalculation['periodofincome'] : ''),
        // tslint:disable-next-line:max-line-length
        secondLifePensionPercentage: null,
        // tslint:disable-next-line:max-line-length
        secondLifePensionPercentageType: '',
        pre88SecondLifePensionPercentageType: '',
        post88SecondLifePensionPercentageType: '',
        // tslint:disable-next-line:max-line-length
        secondLifeAnyOrNamed: '',
        overlapType: 'N',
        minAgeForGarYears: null,
        minAgeForGarMonths: null,
        maxAgeForGarYears: null,
        maxAgeForGarMonths: null,
        vpPercentage: null,
        vpIndicator: 'N',
        vpAmount: null,
        vpBasis: '0',
        careProviderFee: null,
        totalFund: null,
        monthlyIncome: null,
        quickQuoteIdentifier: 1,
        pensionFund: null
      };
    } else if (this.requestQuoteCalculation && (this.requestQuoteCalculation['productType'] === 'G')) {
      data = {
        benefitType: 'N1',
        targeted: null,
        annualIncome: null,
        maturityAmount: 0,
        cedingFundAmount: (this.fundDetails && this.fundDetails.cedingFund) ? this.fundDetails.cedingFund : null,
        externalFundAmount: extFund,
        pre88AnnualIncome: null,
        post88AnnualIncome: null,

        taxFreeCashAmountPercent: (multipleTaxfree || fundProvider !== 'B') ? (this.requestQuoteCalculation['taxfreeRadioButton'] ?
          this.requestQuoteCalculation['taxfreeRadioButton'] : null) : null,

        taxFreeCashPercentage: (fundProvider !== 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
          // tslint:disable-next-line: max-line-length
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary' || taxfree.mode === 'secondary').perc) : null,

        taxFreeCashAmount: (fundProvider !== 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
          // tslint:disable-next-line: max-line-length
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary' || taxfree.mode === 'secondary').value) : null,


        extTaxFreeCashAmountPercent: (multipleTaxfree) ?
          (this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] ?
            this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] : null) :
          ((fundProvider === 'B') ?
            (this.requestQuoteCalculation['taxfreeRadioButton']) : null),
        extTaxFreeCashAmount: (multipleTaxfree) ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value)
          :
          ((fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value) : null),
        extTaxFreeCashPercentage: (multipleTaxfree) ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc)
          :
          ((fundProvider === 'B' && this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 0) ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null),


        netPensionFund: netFund ? netFund : null,
        dateEligibleFrGuarantee: '',
        guaranteeAmt: null,
        proportionIndicator: '',
        escalationType: (this.requestQuoteCalculation['increasedincome'] === 'F') ?
        this.requestQuoteCalculation['increasedincomeslider'] : this.requestQuoteCalculation['increasedincome'],
        // tslint:disable-next-line:max-line-length
        guaranteedTermIndicator: 'F',
        pre88EscalationType: null,
        post88EscalationType: null,
        // tslint:disable-next-line:max-line-length
        escalationRate:  (this.requestQuoteCalculation['increasedincome'] === 'F') ? this.requestQuoteCalculation['increasedincomeslider'] : null,
        // tslint:disable-next-line:max-line-length
        guaranteedTerm: null,
        // tslint:disable-next-line:max-line-length
        secondLifePensionPercentage: null,
        // tslint:disable-next-line:max-line-length
        secondLifePensionPercentageType: 'N',
        pre88SecondLifePensionPercentageType: '',
        post88SecondLifePensionPercentageType: '',
        // tslint:disable-next-line:max-line-length
        secondLifeAnyOrNamed: '',
        overlapType: 'N',
        minAgeForGarYears: null,
        minAgeForGarMonths: null,
        maxAgeForGarYears: null,
        maxAgeForGarMonths: null,
        vpPercentage: null,
        vpIndicator: null,
        vpAmount: null,
        vpBasis: null,
        careProviderFee: null,
        totalFund: null,
        monthlyIncome: null,
        quickQuoteIdentifier: 0,
        pensionFund: 0
      };
    } else {
      data = {
        benefitType: 'N1',
        targeted: null,
        annualIncome: null,
        maturityAmount: null,
        cedingFundAmount: null,
        externalFundAmount: extFund,
        pre88AnnualIncome: null,
        post88AnnualIncome: null,
        taxFreeCashAmountPercent: '',
        taxFreeCashPercentage: '',
        taxFreeCashAmount: '',
        netPensionFund: null,
        dateEligibleFrGuarantee: '',
        guaranteeAmt: null,
        proportionIndicator: '',
        escalationType: '',
        guaranteedTermIndicator: '',
        pre88EscalationType: null,
        post88EscalationType: null,
        escalationRate: '',
        guaranteedTerm: 0,
        secondLifePensionPercentage: '',
        secondLifePensionPercentageType: '',
        pre88SecondLifePensionPercentageType: '',
        post88SecondLifePensionPercentageType: '',
        secondLifeAnyOrNamed: '',
        overlapType: '',
        minAgeForGarYears: null,
        minAgeForGarMonths: null,
        maxAgeForGarYears: null,
        maxAgeForGarMonths: null,
        vpPercentage: null,
        vpIndicator: '',
        vpAmount: null,
        vpBasis: '',
        careProviderFee: null,
        totalFund: null,
        monthlyIncome: null,
        quickQuoteIdentifier: 0,
        pensionFund: 0
      };
    }
    if (this.quoteDataCapture.quoteBasis.quoteType === 'IVPP' && fundProvider === 'B') {
      data.taxFreeCashAmountPercent = data.extTaxFreeCashAmountPercent;
      data.extTaxFreeCashAmountPercent = null;
      data.taxFreeCashPercentage = data.extTaxFreeCashPercentage;
      data.extTaxFreeCashPercentage = null;
      data.taxFreeCashAmount = data.extTaxFreeCashAmount;
      data.extTaxFreeCashAmount = null;
    }
    if (this.fundDetails && this.fundDetails.cedingFund && this.requestQuoteCalculation && fundProvider != 'B') {
      const grossAmount = (this.fundDetails.totalSum - this.fundDetails.cedingFund);
      data.netPensionFund = (this.fundDetails.totalSum - this.requestQuoteCalculation['calculatedTaxFreeLumSum'].reduce((i, b) => {
        return b['value'] + i
      }, 0)).toFixed(2);
      data.cedingFundAmount = this.fundDetails.cedingFund;
      data.externalFundAmount = grossAmount.toFixed(2);
    }
    if (data.externalFundAmount && data.externalFundAmount != '') {
      data.externalFundAmount = (+data.externalFundAmount).toFixed(2)
    }
    if (data.taxFreeTotal && data.taxFreeTotal != '') {
      data.taxFreeTotal = (+data.taxFreeTotal).toFixed(2)
    }
    if (data.extTaxFreeCashAmount && data.extTaxFreeCashAmount != '') {
      data.extTaxFreeCashAmount = (+data.extTaxFreeCashAmount).toFixed(2)
    }
    if (data.taxFreeCashAmount && data.taxFreeCashAmount != '') {
      data.taxFreeCashAmount = (+data.taxFreeCashAmount).toFixed(2);

    }
    if (data.pensionFund && data.pensionFund != '') {
      data.pensionFund = (+data.pensionFund).toFixed(2)

    }
    if (data.cedingFundAmount && data.cedingFundAmount != '') {
      data.cedingFundAmount = (+data.cedingFundAmount).toFixed(2)
    }
    //if(data.taxFreeCashAmountPercent && data.taxFreeCashAmountPercent != '' && data.taxFreeCashAmountPercent != 'N'){
    //  data.taxFreeCashAmountPercent = data.taxFreeCashAmountPercent.toFixed(2)

    //}

    return data;
  }

  processCustomerInformation(data, personalDetails, registerDetails, loginDetails) {
    if (!loginDetails || loginDetails === 'undefined') {
      data.forename = "TBC";
      data.surname = "TBC";
      data.dateOfBirth = personalDetails && personalDetails.dateOfBirth ? personalDetails.dateOfBirth.toString().replace(/ /g, '') : '';
      data.gender = personalDetails && personalDetails.gender ? personalDetails.gender : '';
      data.maritalStatus = personalDetails ? personalDetails.maritalStatus : '';
      data.ukaddressIndicator = personalDetails ? personalDetails.ukaddressIndicator : '';
      data.address.postcode = personalDetails ? personalDetails.postcode : '';
      data.consentDate = personalDetails && personalDetails.consentDate ? personalDetails.consentDate : '';
      data.consentIndicator = personalDetails && personalDetails.consentIndicator ? personalDetails.consentIndicator : '';
      // data.womConsentDate = this.getTodaysDate();
      data.womConsentDate = '';
      data.womConsent = 'N';

    }


    else if (loginDetails) {
      data.forename = loginDetails && loginDetails['customer'].forename ? loginDetails['customer'].forename : 'TBC';
      data.surname = loginDetails && loginDetails['customer'].surname ? loginDetails['customer'].surname : 'TBC';
      data.middleName = loginDetails && loginDetails['customer'].middleName ? loginDetails['customer'].middleName : '';
      data.thirdName = loginDetails && loginDetails['customer'].thirdName ? loginDetails['customer'].thirdName : '';
      data.mobilePhone = loginDetails && loginDetails['customer'].mobilePhone ? loginDetails['customer'].mobilePhone : '';
      data.homePhone = loginDetails && loginDetails['customer'].homePhone ? loginDetails['customer'].homePhone : '';

      data.title = loginDetails && loginDetails['customer'].title ? loginDetails['customer'].title : '';
      data.emailAddress = loginDetails && loginDetails['customer'].emailAddress ? loginDetails['customer'].emailAddress : '';
      data.dateOfBirth = loginDetails && loginDetails['customer'].dateOfBirth ? loginDetails['customer'].dateOfBirth.toString().replace(/ /g, '') : '';
      data.gender = loginDetails && loginDetails['customer'].gender ? loginDetails['customer'].gender : '';
      data.maritalStatus = loginDetails ? loginDetails['customer'].maritalStatus : '';
      data.ukaddressIndicator = loginDetails ? loginDetails['customer'].ukaddressIndicator : '';
      data.address.postcode = loginDetails ? loginDetails['customer']['address'].postcode : '';

      data.address.line1 = loginDetails ? loginDetails['customer']['address'].line1 : '';
      data.address.line2 = loginDetails ? loginDetails['customer']['address'].line2 : '';
      data.address.line3 = loginDetails ? loginDetails['customer']['address'].line3 : '';
      data.address.line4 = loginDetails ? loginDetails['customer']['address'].line4 : '';

      data.internalSoftOptInInd = loginDetails && loginDetails['customer'].internalSoftOptInInd ? loginDetails['customer'].internalSoftOptInInd : '';

      data.consentDate = personalDetails && personalDetails.consentDate ? personalDetails.consentDate : '';
      data.consentIndicator = personalDetails && personalDetails.consentIndicator ? personalDetails.consentIndicator : '';
      // data.womConsentDate = this.getTodaysDate();
      data.womConsentDate = '';
      data.womConsent = 'N';
      data.partyId = loginDetails && loginDetails['customer']['partyId'] ? loginDetails['customer']['partyId'] : '';
      data.pwAppointmentdate = loginDetails && loginDetails['customer'].pwAppointmentdate ? loginDetails['customer'].pwAppointmentdate : null;
      data['customerCareInfo'] = personalDetails && !this.checkIfObjEmpty(personalDetails['customerCareInfo'])
      ? personalDetails['customerCareInfo'] : (loginDetails && loginDetails['customer'] && !this.checkIfObjEmpty(loginDetails['customer']['customerCareInfo'])
        ? loginDetails['customer']['customerCareInfo'] : null);
    }
    if (registerDetails && !this.checkProperties(registerDetails)) {
      // tslint:disable-next-line: max-line-length
      data.forename = registerDetails.forename ? registerDetails.forename.charAt(0).toUpperCase() + registerDetails.forename.slice(1) : 'TBC';
      data.surname = registerDetails.surname ? registerDetails.surname.charAt(0).toUpperCase() + registerDetails.surname.slice(1) : 'TBC';
      // tslint:disable-next-line: max-line-length
      data.middleName = registerDetails.middleName ? registerDetails.middleName.charAt(0).toUpperCase() + registerDetails.middleName.slice(1) : '';
      // tslint:disable-next-line: max-line-length
      data.thirdName = registerDetails.thirdName ? registerDetails.thirdName.charAt(0).toUpperCase() + registerDetails.thirdName.slice(1) : '';
      data.dateOfBirth = registerDetails && registerDetails.dateOfBirth ? registerDetails.dateOfBirth.toString().replace(/ /g, '') : '';
      data.gender = registerDetails && registerDetails.gender ? registerDetails.gender : '';
      data.maritalStatus = registerDetails ? registerDetails.maritalStatus : '';
      data.ukaddressIndicator = registerDetails ? registerDetails.ukaddressIndicator : '';
      // data.address.postcode = registerDetails ? registerDetails.postcode : '';

      if (registerDetails && registerDetails.postcode) {
        data.address.postcode = registerDetails.postcode;
      } else if (registerDetails && registerDetails.address && registerDetails.address.postcode) {
        data.address.postcode = registerDetails.address.postcode;
      } else {
        data.address.postcode = '';
      }
      if (registerDetails && registerDetails.addressline1) {
        data.address.line1 = registerDetails.addressline1;
      } else if (registerDetails && registerDetails.address && registerDetails.address.line1) {
        data.address.line1 = registerDetails.address.line1;
      } else {
        data.address.line1 = '';
      }

      if (registerDetails && registerDetails.addressline2) {
        data.address.line2 = registerDetails.addressline2;
      } else if (registerDetails && registerDetails.address && registerDetails.address.line2) {
        data.address.line2 = registerDetails.address.line2;
      } else {
        data.address.line2 = '';
      }

      if (registerDetails && registerDetails.addressline3) {
        data.address.line3 = registerDetails.addressline3;
      } else if (registerDetails && registerDetails.address && registerDetails.address.line3) {
        data.address.line3 = registerDetails.address.line3;
      } else {
        data.address.line3 = '';
      }

      if (registerDetails && registerDetails.addressline4) {
        data.address.line4 = registerDetails.addressline4;
      } else if (registerDetails && registerDetails.address && registerDetails.address.line4) {
        data.address.line4 = registerDetails.address.line4;
      } else {
        data.address.line4 = '';
      }
      //  data.address.line1 = registerDetails ? registerDetails.addressline1 : '';
      // data.address.line2 = registerDetails ? registerDetails.addressline2 : '';
      // data.address.line3 = registerDetails ? registerDetails.addressline3 : '';
      // data.address.line4 = registerDetails ? registerDetails.addressline4 : '';
      data.emailAddress = registerDetails ? registerDetails.emailAddress : '';
      data.confirmEmailAddress = registerDetails ? registerDetails.confirmEmailAddress : '';
      data.mobilePhone = registerDetails ? registerDetails.mobilePhone : '';
      data.homePhone = registerDetails ? registerDetails.homePhone : '';
      data.internalSoftOptInInd = registerDetails && registerDetails.internalSoftOptInInd ? registerDetails.internalSoftOptInInd : 'Y';


      // if (registerDetails.userTitle === 'Other') {
      data.otherTitle = registerDetails ? registerDetails.otherTitle : '';
      // }
      // else {
      data.title = registerDetails ? registerDetails.userTitle : '';
      // }

    }
    data['quotePurpose'] = data && data['quotePurpose'] && data['quotePurpose'] !== '' ? data['quotePurpose'] : 'R';
    //console.log("sending data", data);
    return data;
  }

  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }

  processDependentInformation(data, dependentDetails) {
    data.dateOfBirth = dependentDetails && dependentDetails.dateOfBirth ? dependentDetails.dateOfBirth.toString().replace(/ /g, '') : '';
    data.relationshipToCustomer = dependentDetails && dependentDetails.relationship ? dependentDetails.relationship : '';
    data.gender = dependentDetails && dependentDetails.gender ? dependentDetails.gender : '';

    return data;
  }

  removeDuplicateFromArray(array: Array<any>) {
    // return [... Array.from(new Set(array))];
    // return array.filter(( item, index) => array.indexOf(item) === index);
    return array.filter((item, index) => {
      const _thing = JSON.stringify(item);
      return index === array.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    })
  }
  createDefaultFundModelObject() {

    let fundObject = {
      fundValue: 0,
      transferType: '',
      policyNo: null,
      productName: null,
      schemeName: null,
      retirementDate: '',
      requiredTFC: 0,
      withProfitsInd: '',
      fullFundInd: '',
      revaluedPTFC: 0,
      bankruptcy: '',
      ptfcInd: '',
      tfcInd: null,
      title: null,
      forename: null,
      surname: null,
      dateOfBirth: null,
      postcode: null,
      transferValue: '',
      productCode: null
    };
    return fundObject;
  }
  createDefaultProductCodeModelObject() {
    let productCodeObject = {
      productCode: "",
      productDescription: "",
      productGroup: "",
      validProductCode: "",
      matchSpecialInstruction: "",
      productCategory: "",
      specialInstruction: "",
      benefitsView: "",
      womEligibility: ""
    };

    return productCodeObject
  }
  getProductChoice() {


    return this.http.get(this.endPoints.getQuoteDataCapture).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  postQuickQuoteValues(isValidationRequired: boolean = true, index): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    console.log('this.quoteDataCapture' , this.quoteDataCapture);
    this.getScreenName();
    this.processQuoteInformation(isValidationRequired, index);
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.calculateQuickQuote).
        map((res: Response) => {
          let newBenefitVariants = (res && res['benefitVariants'] &&
            res['benefitVariants'].length > 0) ? res['benefitVariants'] : [];
          newBenefitVariants = newBenefitVariants[newBenefitVariants.length - 1];
          // tslint:disable-next-line: max-line-length
          if (newBenefitVariants && ((newBenefitVariants.errorACE && newBenefitVariants.errorACE.length > 0) ||
            (newBenefitVariants.warning && newBenefitVariants.warning.length > 0))) {
            let errorObject = {
              error: '',
              warning: ''
            };
            console.log('chk here' , newBenefitVariants.errorACE[0]);
            // tslint:disable-next-line:max-line-length
            errorObject.error = (newBenefitVariants.errorACE && newBenefitVariants.errorACE[0]) ? newBenefitVariants.errorACE[0].trim() : null;
            // tslint:disable-next-line:max-line-length
            errorObject.warning = (newBenefitVariants.warning && newBenefitVariants.warning[0]) ? newBenefitVariants.warning[0].trim() : null;
            // if maturity amount is very high
            if (errorObject.warning && errorObject.warning.includes('Quote varied to maximum Mat Value that can be supported')) {
              this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
              this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
              return res;
            } else {
              return errorObject;
            }
          } else {
            this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
            this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
            return res;
          }
        }
        );
    } else {
      return this.http.post<any>(this.endPoints.calculateQuickQuote, this.quoteDataCapture, httpOptions).
        map((res: Response) => {
          let newBenefitVariants = (res && res['benefitVariants'] &&
            res['benefitVariants'].length > 0) ? res['benefitVariants'] : [];
          newBenefitVariants = newBenefitVariants[newBenefitVariants.length - 1];
          // tslint:disable-next-line: max-line-length
          if (newBenefitVariants && ((newBenefitVariants.errorACE && newBenefitVariants.errorACE.length > 0) ||
            (newBenefitVariants.warning && newBenefitVariants.warning.length > 0))) {
            let errorObject = {
              error: '',
              warning: ''
            };
            // tslint:disable-next-line:max-line-length
            errorObject.error = (newBenefitVariants.errorACE && newBenefitVariants.errorACE[0]) ? newBenefitVariants.errorACE[0].trim() : null;
            // tslint:disable-next-line:max-line-length
            errorObject.warning = (newBenefitVariants.warning && newBenefitVariants.warning[0]) ? newBenefitVariants.warning[0].trim() : null;
            // if maturity amount is very high
            if (errorObject.warning && errorObject.warning.includes('Quote varied to maximum Mat Value that can be supported')) {
              this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
              this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
              return res;
            } else {
              return errorObject;
            }
          } else {
            console.log('in else');
            this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
            console.log('after in else' , res);
            this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
            console.log('after in else' , res);
            return res;
          }
        }
        );
    }
  }
  refreshCard(isValidationRequired: boolean = true, index): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    if (this.responseQuoteCalculation && this.responseQuoteCalculation['benefitVariants']) {
      this.responseQuoteCalculation['benefitVariants'][index]['refreshCard'] = true;
    }
    this.getScreenName();
    this.processQuoteInformation(isValidationRequired, null);
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.calculateQuickQuote).map((res: Response) => {
        this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
        this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
        return res['benefitVariants'];
      });
    } else {
      return this.http.post<any>(this.endPoints.calculateQuickQuote, this.quoteDataCapture, httpOptions).
        map((res: Response) => {
          this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
          return res['benefitVariants'];
        });
    }
  }

  quoteDataCaptureStructure() {
    return {
      quoteRefNo: '',
      formSessionId: '',
      channelType: 'D',
      source: '',
      isEditMode: '',
      isValidated: null,
      userProductRole: '',
      searchQuoteType: '',
      userProductCommencementRole: '',
      product: '',
      productCodeModels: [],
      sourceforDCJ: '',
      applicationType: 'C',
      cameFromMicrosite: false,
      dealPartnerProductModel: {
        dealpartnerCode: '',
        product: 'C',
        productCodeModels: [],
        benefitTypes: []
      },
      customer: {
        consentIndicator: '',
        consentDate: '',
        womConsent: '',
        womConsentDate: '',
        title: '',
        otherTitle: '',
        surname: 'TBC',
        forename: 'TBC',
        middleName: '',
        thirdName: '',
        dateOfBirth: '',
        ukaddressIndicator: '',
        emailAddress: '',
        confirmEmailAddress: '',
        homePhone: '',
        mobilePhone: '',
        contactNumber: '',
        address: {
          countryCode: '',
          postcode: '',
          line1: '',
          line2: '',
          line3: '',
          line4: ''
        },
        gender: '',
        maritalStatus: '',
        bankruptInd: '',
        careProviderName: '',
        isEditMode: '',
        partyId: '',
        internalSoftOptInInd: null,
        quotePurpose: null,
        customerCareInfo: null
      },
      broker: null,
      fundModel: [],
      quoteBasis: {
        quoteType: '',
        commencementDate: '',
        paymentFrequency: '',
        paymentAdvance: '',
        policyTerm: null,
        policyTermMonths: 0,
        selectedRetirementDate: null,
        cedingPolicyNos: '',
        quoteRateDate: null,
        currentRate: '',
        productCode: '',
        dealPartnerPolicyStrtDt: null,
        guaranteedAnnuityRate: '',
        earlyRetirement: '',
        profitAdjustmentInd: '',
        profitAdjustmentPercentage: null,
        requoteCurrentRateFlag: '',
        fundingType: '',
        customerNeed: 'RT',
        rateGuaranteeQuoteInd: '',
        invalid: false
      },
      benefitBasis: {
        benefitType: '',
        targeted: null,
        annualIncome: null,
        maturityAmount: null,
        cedingFundAmount: null,
        externalFundAmount: null,
        pre88AnnualIncome: null,
        post88AnnualIncome: null,
        taxFreeCashAmountPercent: '',
        extTaxFreeCashAmountPercent: '',
        taxFreeCashPercentage: '',
        extTaxFreeCashPercentage: '',
        taxFreeCashAmount: '',
        extTaxFreeCashAmount: '',
        netPensionFund: null,
        dateEligibleFrGuarantee: '',
        guaranteeAmt: null,
        proportionIndicator: '',
        escalationType: '',
        guaranteedTermIndicator: 'O',
        pre88EscalationType: null,
        post88EscalationType: null,
        escalationRate: '',
        guaranteedTerm: 0,
        secondLifePensionPercentage: '',
        secondLifePensionPercentageType: '',
        pre88SecondLifePensionPercentageType: '',
        post88SecondLifePensionPercentageType: '',
        secondLifeAnyOrNamed: 'N',
        overlapType: '',
        minAgeForGarYears: null,
        minAgeForGarMonths: null,
        maxAgeForGarYears: null,
        maxAgeForGarMonths: null,
        vpPercentage: null,
        vpIndicator: '',
        vpAmount: null,
        vpBasis: '0',
        careProviderFee: null,
        totalFund: null,
        monthlyIncome: null,
        quickQuoteIdentifier: 0,
        pensionFund: 0
      },
      secondLife: {
        title: '',
        surname: 'TBC',
        forename: 'TBC',
        middleName: '',
        gender: '',
        dateOfBirth: '',
        relationshipToCustomer: '',
        maritalStatus: ''
      },
      underwriting: {
        underwritingLife: this.underwritingLifeValue,
        netAmount: null,
        annUnderwritingDecision: null,
        depUnderwritingDecision: null,
        uwDecision: 'N',
        uwDecisionExpiry: null,
        uwDirtyData: null,
        lifeExpectancy: null,
        vectorCode: null
      },
      benefitVariants: [],
      riskAndStaticQuestion: [],
      riskFormCompleted: false,
      currentScreen: '',
      validate: true,
      underwritingData: {
        annuitantMedicalConditions: [],
        dependentMedicalConditions: []
      },
      aceCalCounter: 0,
      triggeredBy: 'DCJ',
      requote: this.requoteFlag,
      fundValidateInd: false
    };
  }

  getQuickQuoteCounter(): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.calculateQuickQuote).map((res: Response) => {
        //console.log('getQuickQuoteCounter res', res);
        return res;
        // let newBenefitVariants = (res && res['benefitVariants'] &&
        //   res['benefitVariants'].length > 0) ? res['benefitVariants'] : [];
        // if (newBenefitVariants.length > 0) {
        //   newBenefitVariants = newBenefitVariants.filter(val => val.cardNumber === editIndex);
        // }
        // newBenefitVariants = newBenefitVariants.length > 0 ? newBenefitVariants[0] : [];
        // tslint:disable-next-line: max-line-length
        // if ((newBenefitVariants.errorACE && newBenefitVariants.errorACE.length > 0) ||
        //   (newBenefitVariants.warning && newBenefitVariants.warning.length > 0)) {
        //   let errorObject = {
        //     error: '',
        //     warning: ''
        //   };
        // tslint:disable-next-line:max-line-length
        // tslint:disable-next-line:max-line-length
        // errorObject.error = (newBenefitVariants.errorACE && newBenefitVariants.errorACE[0]) ? newBenefitVariants.errorACE[0].trim() : null;
        // tslint:disable-next-line:max-line-length
        // errorObject.warning = (newBenefitVariants.warning && newBenefitVariants.warning[0]) ? newBenefitVariants.warning[0].trim() : null;
        // if maturity amount is very high
        // if (errorObject.warning.includes('Quote varied to maximum Mat Value that can be supported')) {
        //   res['benefitVariants'] = this.responseQuoteCalculation['benefitVariants'];
        //   this.updateCard(res, editIndex);
        //   this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
        //   this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
        //   return res;
        // } else {
        //   return errorObject;
        // }
        // } else {
        //   res['benefitVariants'] = this.responseQuoteCalculation['benefitVariants'];
        //   this.updateCard(res, editIndex);
        //   this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
        //   this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
        //   return res;
        // }
      });
    } else {
      return this.http.post<any>(this.endPoints.calculateQuickQuote, this.quoteDataCapture, httpOptions).
        map((res: Response) => {
          // let newBenefitVariants = (res && res['benefitVariants'] &&
          //   res['benefitVariants'].length > 0) ? res['benefitVariants'] : [];
          // if (newBenefitVariants.length > 0) {
          //   newBenefitVariants = newBenefitVariants.filter(val => val.cardNumber === editIndex);
          // }
          // newBenefitVariants = newBenefitVariants.length > 0 ? newBenefitVariants[0] : [];
          // tslint:disable-next-line: max-line-length
          // if ((newBenefitVariants.errorACE && newBenefitVariants.errorACE.length > 0) ||
          //   (newBenefitVariants.warning && newBenefitVariants.warning.length > 0)) {
          //   let errorObject = {
          //     error: '',
          //     warning: ''
          //   };
          // tslint:disable-next-line:max-line-length
          // errorObject.error = (newBenefitVariants.errorACE && newBenefitVariants.errorACE[0]) ? newBenefitVariants.errorACE[0].trim() : null;
          // tslint:disable-next-line:max-line-length
          // errorObject.warning = (newBenefitVariants.warning && newBenefitVariants.warning[0]) ? newBenefitVariants.warning[0].trim() : null;
          // if (errorObject.warning && errorObject.warning.includes('Quote varied to maximum Mat Value that can be supported')) {
          //   this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          //   this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
          //   return res;
          // } else {
          //   return errorObject;
          // }
          // } else {
          //   this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          //   this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
          //   return res;
          // }
        }
        );
    }
  }
  editQuickQuoteValues(isValidationRequired: boolean = true, editIndex): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    this.getScreenName();
    this.processQuoteInformation(isValidationRequired, editIndex);


    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.calculateQuickQuote).map((res: Response) => {
        let newBenefitVariants = (res && res['benefitVariants'] &&
          res['benefitVariants'].length > 0) ? res['benefitVariants'] : [];
        if (newBenefitVariants.length > 0) {
          newBenefitVariants = newBenefitVariants.filter(val => val.cardNumber === editIndex);
        }
        newBenefitVariants = newBenefitVariants.length > 0 ? newBenefitVariants[0] : [];
        // tslint:disable-next-line: max-line-length
        if ((newBenefitVariants.errorACE && newBenefitVariants.errorACE.length > 0) ||
          (newBenefitVariants.warning && newBenefitVariants.warning.length > 0)) {
          let errorObject = {
            error: '',
            warning: ''
          };
          // tslint:disable-next-line:max-line-length
          // tslint:disable-next-line:max-line-length
          errorObject.error = (newBenefitVariants.errorACE && newBenefitVariants.errorACE[0]) ? newBenefitVariants.errorACE[0].trim() : null;
          // tslint:disable-next-line:max-line-length
          errorObject.warning = (newBenefitVariants.warning && newBenefitVariants.warning[0]) ? newBenefitVariants.warning[0].trim() : null;
          // if maturity amount is very high
          if (errorObject.warning.includes('Quote varied to maximum Mat Value that can be supported')) {
            res['benefitVariants'] = this.responseQuoteCalculation['benefitVariants'];
            this.updateCard(res, editIndex);
            this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
            this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
            return res;
          } else {
            return errorObject;
          }
        } else {
          res['benefitVariants'] = this.responseQuoteCalculation['benefitVariants'];
          this.updateCard(res, editIndex);
          this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
          return res;
        }
      });
    } else {
      return this.http.post<any>(this.endPoints.calculateQuickQuote, this.quoteDataCapture, httpOptions).
        map((res: Response) => {
          let newBenefitVariants = (res && res['benefitVariants'] &&
            res['benefitVariants'].length > 0) ? res['benefitVariants'] : [];
          if (newBenefitVariants.length > 0) {
            newBenefitVariants = newBenefitVariants.filter(val => val.cardNumber === editIndex);
          }
          newBenefitVariants = newBenefitVariants.length > 0 ? newBenefitVariants[0] : [];
          // tslint:disable-next-line: max-line-length
          if ((newBenefitVariants.errorACE && newBenefitVariants.errorACE.length > 0) ||
            (newBenefitVariants.warning && newBenefitVariants.warning.length > 0)) {
            let errorObject = {
              error: '',
              warning: ''
            };
            // tslint:disable-next-line:max-line-length
            errorObject.error = (newBenefitVariants.errorACE && newBenefitVariants.errorACE[0]) ? newBenefitVariants.errorACE[0].trim() : null;
            // tslint:disable-next-line:max-line-length
            errorObject.warning = (newBenefitVariants.warning && newBenefitVariants.warning[0]) ? newBenefitVariants.warning[0].trim() : null;
            if (errorObject.warning && errorObject.warning.includes('Quote varied to maximum Mat Value that can be supported')) {
              this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
              this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
              return res;
            } else {
              return errorObject;
            }
          } else {
            this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
            this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(res));
            return res;
          }
        }
        );
    }
  }
  addNewCard(res, index) {
    const newCardRequest = this.requestQuoteCalculation;
    let multipleTaxfree = (this.requestQuoteCalculation && this.requestQuoteCalculation['calculatedTaxFreeLumSum'] &&
      this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 1) ? true : false;
    let fundProvider = (this.fundDetails && this.fundDetails.fundProvider) ?
      this.fundDetails.fundProvider : null;
    if (res && res.benefitVariants) {
      res.benefitVariants.push({
        cardNumber: index,
        selected: false,
        refresh: false,
        startDate: '26/07/2019',
        warning: null,
        errorACE: [""],
        benefitBasisModel: {
          // tslint:disable-next-line:max-line-length
          escalationRate: (newCardRequest['increasedincomeslider'] && (newCardRequest['increasedincome'] === 'test')) ? (newCardRequest['increasedincomeslider'].toString().includes('%') ? newCardRequest['increasedincomeslider'] : newCardRequest['increasedincomeslider'] + '%') : null,
          escalationType: newCardRequest['increasedincome'],
          // No Product code check ?
          guaranteedTerm: newCardRequest['periodofincome'],
          // No need to check Product ?
          guaranteedTermIndicator: newCardRequest['periodofincomequestion'] ? newCardRequest['periodofincomequestion'] : (newCardRequest['periodofincome'] === 0 ? 'N' : 'O'),
          secondLifeAnyOrNamed: 'N',
          overlapType: null,
          secondLifePensionPercentage: (newCardRequest['incomepercentage'] === null) ? 'N' : newCardRequest['incomepercentage'],
          secondLifePensionPercentageType: (newCardRequest['incomepercentage'] === null) ? null : newCardRequest['incomepercentage'],
          taxFreeCashAmountPercent: (multipleTaxfree || fundProvider !== 'B') ? (this.requestQuoteCalculation['taxfreeRadioButton'] ?
            this.requestQuoteCalculation['taxfreeRadioButton'] : null) : null,
          extTaxFreeCashAmountPercent: (multipleTaxfree) ?
            (this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] ?
              this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] : null) :
            ((fundProvider === 'B') ?
              (this.requestQuoteCalculation['taxfreeRadioButton']) : null),
          taxFreeCashPercentage: (fundProvider !== 'B') ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null,
          extTaxFreeCashPercentage: (multipleTaxfree) ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc)
            :
            ((fundProvider === 'B') ?
              (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null),
          taxFreeCashAmount: (fundProvider !== 'B') ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null,
          extTaxFreeCashAmount: (multipleTaxfree) ?
            (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value.toFixed(2))
            :
            ((fundProvider === 'B') ?
              (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null),
          vpAmount: null,
          vpBasis: '0',
          vpIndicator: newCardRequest['valueprotection'],
          // tslint:disable-next-line:max-line-length
          vpPercentage: (newCardRequest['valueprotection'] === 'Ann' && (this.dependentDetail && this.dependentDetail.dependantQuestion === 'N')) ? newCardRequest['vpslider'] : null,
          // tslint:disable-next-line:max-line-length
          annualIncome: (newCardRequest['incomematurity'] === 'Y') ? CurrencyFunctionalityService.convertCurrencyToNumber(newCardRequest['fundValue']) : null,
          // tslint:disable-next-line:max-line-length
          maturityAmount: (newCardRequest['incomematurity'] === 'M') ? CurrencyFunctionalityService.convertCurrencyToNumber(newCardRequest['fundValue']) : null
        },
        quoteBasisModel: {
          // tslint:disable-next-line: max-line-length
          commencementDate: this.requestQuoteCalculation['startDate'] ? this.requestQuoteCalculation['startDate'].toString().replace(/ /g, '') : null,
          startDateType: this.requestQuoteCalculation['currentDate'] === 'A' ? 'As Soon As Possible' : null,
          paymentAdvance: newCardRequest['advance'] ? newCardRequest['advance'] : '',
          paymentFrequency: newCardRequest['frequency'] ? newCardRequest['frequency'] : '',
          policyTerm: newCardRequest['termplan'] ? newCardRequest['termplan'] :
            (newCardRequest['termyear'] ? newCardRequest['termyear'] : ''),
          policyTermMonths: newCardRequest['termmonth'] ? newCardRequest['termmonth'] : ''
        },
        quickQuoteModel: {
          annuitantPension: 83.34,
          annuitantYearlyPension: 1000.08,
          // channelType: null,
          dependantPension: 189.96,
          eapQuoteRefNo: null,
          annuitantMaturity: 144276.00,
          // tslint:disable-next-line:max-line-length
          // escalationRate: newCardRequest['increasedincomeslider'].toString().includes('%') ? newCardRequest['increasedincomeslider'] : newCardRequest['increasedincomeslider'] + '%',
          // escalationType: newCardRequest['increasedincome'],
          formSessionId: null,
          // guaranteedTerm: newCardRequest['periodofincome'],
          // guaranteedTermIndicator: newCardRequest['periodofincome'] === 0 ? 'N' : 'O',
          isEditMode: null,
          // overlapType: null,
          // paymentAdvance: newCardRequest['advance'] ? newCardRequest['advance'] : '',
          // paymentFrequency: newCardRequest['frequency'] ? newCardRequest['frequency'] : '',
          portalIndicator: null,
          quoteRefNo: null,
          quoteStatus: null,
          searchQuoteType: null,
          // secondLifeAnyOrNamed: 'N',
          // secondLifePensionPercentage: (newCardRequest['incomepercentage'] === null) ? 'N' : newCardRequest['incomepercentage'],
          // secondLifePensionPercentageType: (newCardRequest['incomepercentage'] === null) ? null : newCardRequest['incomepercentage'],
          // selected: false,
          source: null,

          // taxFreeCashAmount: newCardRequest['calculatedTaxFreeLumSum'] ? newCardRequest['calculatedTaxFreeLumSum'] : 0,
          // taxFreeCashAmountPercent: 'P',
          // taxFreeCashPercentage: newCardRequest['taxfreelumpsum'],
          totalConsideration: 10001,
          userName: null,
          userProductCommencementRole: null,
          userProductRole: null,
          uwReferenceNo: null,
          // vpAmount: null,
          // vpBasis: '0',
          // vpIndicator: newCardRequest['valueprotection'],
          // vpPercentage: null
        }
      });
    }
  }

  updateCard(res, i) {
    const newCardRequest = this.requestQuoteCalculation;
    let multipleTaxfree = (this.requestQuoteCalculation && this.requestQuoteCalculation['calculatedTaxFreeLumSum'] &&
      this.requestQuoteCalculation['calculatedTaxFreeLumSum'].length > 1) ? true : false;
    let fundProvider = (this.fundDetails && this.fundDetails.fundProvider) ?
      this.fundDetails.fundProvider : null;
    if (res && res.benefitVariants.length > 0 && this.requestQuoteCalculation['productType'] === 'H') {
      // tslint:disable-next-line:no-shadowed-variable
      let benefitList = res.benefitVariants.filter(res => {
        return res.cardNumber === i;
      });
      // tslint:disable-next-line:max-line-length
      benefitList[0].quoteBasisModel.commencementDate = newCardRequest['startDate'] ? newCardRequest['startDate'].toString().replace(/ /g, '') : '';
      benefitList[0].quoteBasisModel.startDateType = newCardRequest['currentDate'] ? newCardRequest['currentDate'] : '';
      benefitList[0].quoteBasisModel.paymentAdvance = newCardRequest['advance'] ? newCardRequest['advance'] : '';
      benefitList[0].quoteBasisModel.paymentFrequency = newCardRequest['frequency'] ? newCardRequest['frequency'] : '';
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.taxFreeCashAmount = (fundProvider !== 'B') ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null;
      benefitList[0].benefitBasisModel.taxFreeCashPercentage = (fundProvider !== 'B') ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null;
      benefitList[0].benefitBasisModel.taxFreeCashAmountPercent = (multipleTaxfree || fundProvider !== 'B')
        ? (this.requestQuoteCalculation['taxfreeRadioButton'] ?
          this.requestQuoteCalculation['taxfreeRadioButton'] : null) : null;
      benefitList[0].benefitBasisModel.extTaxFreeCashAmountPercent = (multipleTaxfree) ?
        (this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] ?
          this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] : null) :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['taxfreeRadioButton']) : null);
      benefitList[0].benefitBasisModel.extTaxFreeCashPercentage = (multipleTaxfree) ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc)
        :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null);
      benefitList[0].benefitBasisModel.extTaxFreeCashAmount = (multipleTaxfree) ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value.toFixed(2))
        :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null);
      benefitList[0].benefitBasisModel.guaranteedTerm = newCardRequest['periodofincomequestion'] === 'O' ? newCardRequest['periodofincome'] : '';
      benefitList[0].benefitBasisModel.guaranteedTermIndicator = newCardRequest['periodofincomequestion'];
      benefitList[0].quoteBasisModel.policyTerm = newCardRequest['termplan'] ? newCardRequest['termplan'] : null;
      benefitList[0].quoteBasisModel.policyTermMonths = newCardRequest['termmonth'] ? newCardRequest['termmonth'] : null;
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.annualIncome = (newCardRequest['incomematurity'] === 'Y') ? CurrencyFunctionalityService.convertCurrencyToNumber(newCardRequest['fundValue']) : null;
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.maturityAmount = (newCardRequest['incomematurity'] === 'M') ? CurrencyFunctionalityService.convertCurrencyToNumber(newCardRequest['fundValue']) : null;
    } else if (res && res.benefitVariants.length > 0 && this.requestQuoteCalculation['productType'] === 'G') {
      // tslint:disable-next-line:no-shadowed-variable
      let benefitList = res.benefitVariants.filter(res => {
        return res.cardNumber === i;
      });
      // tslint:disable-next-line:max-line-length
      benefitList[0].quoteBasisModel.commencementDate = newCardRequest['startDate'] ? newCardRequest['startDate'].toString().replace(/ /g, '') : '';
      benefitList[0].quoteBasisModel.startDateType = newCardRequest['currentDate'] ? newCardRequest['currentDate'] : '';
      benefitList[0].quoteBasisModel.paymentAdvance = newCardRequest['advance'] ? newCardRequest['advance'] : '';
      benefitList[0].quoteBasisModel.paymentFrequency = newCardRequest['frequency'] ? newCardRequest['frequency'] : '';
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.taxFreeCashAmount = (fundProvider !== 'B') ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null;
      benefitList[0].benefitBasisModel.taxFreeCashPercentage = (fundProvider !== 'B') ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null;
      benefitList[0].benefitBasisModel.taxFreeCashAmountPercent = (multipleTaxfree || fundProvider !== 'B')
        ? (this.requestQuoteCalculation['taxfreeRadioButton'] ?
          this.requestQuoteCalculation['taxfreeRadioButton'] : null) : null;
      benefitList[0].benefitBasisModel.extTaxFreeCashAmountPercent = (multipleTaxfree) ?
        (this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] ?
          this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] : null) :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['taxfreeRadioButton']) : null);
      benefitList[0].benefitBasisModel.extTaxFreeCashPercentage = (multipleTaxfree) ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc)
        :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null);
      benefitList[0].benefitBasisModel.extTaxFreeCashAmount = (multipleTaxfree) ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value.toFixed(2))
        :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null);
      benefitList[0].quoteBasisModel.policyTerm = newCardRequest['termyear'] ? newCardRequest['termyear'] : null;
      benefitList[0].quoteBasisModel.policyTermMonths = newCardRequest['termmonth'] ? newCardRequest['termmonth'] : null;
    } else if (res && res.benefitVariants.length > 0) {
      // tslint:disable-next-line:no-shadowed-variable
      let benefitList = res.benefitVariants.filter(res => {
        return res.cardNumber === i;
      });
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.escalationRate = (newCardRequest['increasedincomeslider'] && (newCardRequest['increasedincome'] === 'F')) ? (newCardRequest['increasedincomeslider'].toString().includes('%') ? newCardRequest['increasedincomeslider'] : newCardRequest['increasedincomeslider'] + '%') : null;
      benefitList[0].benefitBasisModel.escalationType = (newCardRequest['increasedincomeslider'] &&
        (newCardRequest['increasedincome'] === 'F')) ? (newCardRequest['increasedincomeslider'].toString().includes('%') ?
          newCardRequest['increasedincomeslider'] : newCardRequest['increasedincomeslider'] + '%') : null;
      benefitList[0].benefitBasisModel.guaranteedTerm = newCardRequest['periodofincome'];
      benefitList[0].benefitBasisModel.guaranteedTermIndicator = newCardRequest['periodofincome'] === 0 ? 'N' : 'O';
      // tslint:disable-next-line:max-line-length
      benefitList[0].quoteBasisModel.commencementDate = newCardRequest['startDate'] ? newCardRequest['startDate'].toString().replace(/ /g, '') : '';
      benefitList[0].quoteBasisModel.startDateType = newCardRequest['currentDate'] ? newCardRequest['currentDate'] : '';
      benefitList[0].quoteBasisModel.paymentAdvance = newCardRequest['advance'] ? newCardRequest['advance'] : '';
      benefitList[0].quoteBasisModel.paymentFrequency = newCardRequest['frequency'] ? newCardRequest['frequency'] : '';
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.secondLifePensionPercentage = (newCardRequest['incomepercentage'] === null) ? 'N' : newCardRequest['incomepercentage'];
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.secondLifePensionPercentageType = (newCardRequest['incomepercentage'] === null) ? null : newCardRequest['incomepercentage'];
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.taxFreeCashAmount = (fundProvider !== 'B') ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null;
      benefitList[0].benefitBasisModel.taxFreeCashPercentage = (fundProvider !== 'B') ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null;
      benefitList[0].benefitBasisModel.taxFreeCashAmountPercent = (multipleTaxfree || fundProvider !== 'B')
        ? (this.requestQuoteCalculation['taxfreeRadioButton'] ?
          this.requestQuoteCalculation['taxfreeRadioButton'] : null) : null;
      benefitList[0].benefitBasisModel.extTaxFreeCashAmountPercent = (multipleTaxfree) ?
        (this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] ?
          this.requestQuoteCalculation['taxfreeRadioButtonSecondary'] : null) :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['taxfreeRadioButton']) : null);
      benefitList[0].benefitBasisModel.extTaxFreeCashPercentage = (multipleTaxfree) ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').perc)
        :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').perc) : null);
      benefitList[0].benefitBasisModel.extTaxFreeCashAmount = (multipleTaxfree) ?
        (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'secondary').value.toFixed(2))
        :
        ((fundProvider === 'B') ?
          (this.requestQuoteCalculation['calculatedTaxFreeLumSum'].find(taxfree => taxfree.mode === 'primary').value.toFixed(2)) : null);
      benefitList[0].benefitBasisModel.vpIndicator = newCardRequest['valueprotection'];
      // tslint:disable-next-line:max-line-length
      benefitList[0].benefitBasisModel.vpPercentage = (newCardRequest['valueprotection'] === 'Ann' && (this.dependentDetail && this.dependentDetail.dependantQuestion === 'N')) ? newCardRequest['vpslider'] : null;
    }
  }

  postQuoteRequest(): Observable<any> {
    // this.quoteDataCapture.customer = this.processCustomerInformation(this.quoteDataCapture.customer, this.personDetail);
    this.quoteDataCapture = this.quoteDataCaptureStructure();

    this.getScreenName();
    this.processQuoteInformation(true, null);
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.getQuote).pipe(
        map((res: Response) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
          this.store.dispatch(new quoteResultActions.AddQuoteResult(res));
          return res;
        }),
        filter(res => res['lock'] !== true)
      );
    } else {
      //console.log(this.endPoints.saveQuoteDataCapture);
      return this.http.post<any>(this.endPoints.getQuote, this.quoteDataCapture, httpOptions).pipe(
        map((res: Response) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
          this.store.dispatch(new quoteResultActions.AddQuoteResult(res));
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
      );
    }
  }

  getAllGuaranteedQuote(accountId: string): Observable<any[]> {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.getAllGuaranteedQuote);
    } else {
      return this.http.post<any[]>(this.endPoints.getAllGuaranteedQuote, accountId, httpOptions).
        map(res => {
          return res;
        });
    }
  }
  getGuaranteedQuote(padRefNum: string, triggeredBy = 'DCJ'): Observable<any[]> {
    let quoteRef = { 'requestId': padRefNum, triggeredBy: triggeredBy };
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.getGuaranteedQuote);
    } else {
      return this.http.post<any[]>(this.endPoints.getGuaranteedQuote, quoteRef, httpOptions).
        map(res => {
          return res;
        });
    }
  }
  deleteGuaranteedQuote(padRefNum: string): Observable<any[]> {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.getGuaranteedQuote);
    } else {
      return this.http.post<any[]>(this.endPoints.deleteGuaranteedQuote, padRefNum, httpOptions).
        map(res => {
          return res;
        });
    }
  }
  postLoginCapture(showWarning = '', message = '', quoteRefNo: string): Observable<any> {

    const loginReqObj = {
      formSessionId: '',
      quoteRefNo: '',
      currentScreen: '',
      customer: null,
      showWarning: '',
      message: ''
    };
    loginReqObj.formSessionId = this.formSessionId;
    loginReqObj.quoteRefNo = quoteRefNo;
    // loginReqObj.currentScreen = this.screenName;
    loginReqObj.showWarning = showWarning;
    loginReqObj.message = message;
    // this.getScreenName();
    // this.processQuoteInformation(isValidationRequired, null);

    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.loginUser).map((res: Response) => {
        this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
        this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(res));
        return res;
      });
    } else {
      return this.http.post<any>(this.endPoints.loginUser, loginReqObj, httpOptions).
        map((res: any) => {
          if (res.currentScreen == "guidanceAndAdvice" && res.quoteRefNo == null) {
            const part_id = res['customer'].partyId;
            this.startQuoteService.getQuoteReferenceNumber(part_id).subscribe(data => {
              data.quoteNumberFlag = 1;
              data.editMode = false;
              data.applicationRefNumber = null
              this.store.dispatch(new RefNoActions.AddReferenceNumber(data));
            })
          }
          return res
          // this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
          // this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(res));
        }
        );
    }
  }
  deletecard(yourOptions) {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.deleteBenefitCard).pipe(
        map((res: Response) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          res['benefitVariants'] = this.responseQuoteCalculation['benefitVariants'];
          this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(yourOptions));
          return res;
        }),
        filter(res => res['lock'] !== true)
      );

    } else {
      return this.http.post<any>(this.endPoints.deleteBenefitCard, yourOptions, httpOptions).pipe(
        map((res: Response) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
          this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(yourOptions));
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
      );

    }
  }

  loginRedirect(url: string) {
    window.open(url, '_self');
  }
  resetPasswordRedirect(url: string) {
    window.open(url, '_blank');
  }
  searchAddress(searchtext) {
    //console.log('test');
    return this.searchEntries(searchtext).map((res => {
      return res['results'];
    }));
  }
  searchEntries(searchtext) {
    // tslint:disable-next-line: max-line-length
    // return this.http.get<any>(`https://api.edq.com/capture/address/v2/search?query=${searchtext}&country=GBR&take=100&Auth-token=e797eb4a-b562-4b84-8962-0f6fd4964119`)
    // tslint:disable-next-line: max-line-length

    if (searchtext.length === 0) {
      return of([{
        results: [
          {
            suggestion: '',
            format: ''
          }]
      }]);
    } else {
      // tslint:disable-next-line: max-line-length
      return this.http.get<any>(`${this.endPoints.qasAddressSearch}=${searchtext}&country=GBR&take=100`, { headers: new HttpHeaders().set('Auth-token', this.endPoints.qasAddressSearchPassword) })
        .pipe(
        map((res: Response) => {
          return res;
        }
          // err => //console.log(err)
        ),
        catchError(err => of([{
          results: [
            {
              suggestion: 'No record Found',
              format: ''
            }]
        }]))
        );
    }
  }

  searchDummyAddress() {
    return this.http.get<any>(this.endPoints.noAddressFound)
      .map((resdummy: Response) => {
        return resdummy['results'];
      });
  }
  getFormattedAddress(url) {
    return this.http.get<any>(`${url}&Auth-token=${this.endPoints.qasAddressSearchPassword}`)
      .map((res: Response) => {
        return res['address'];
      },
      err => err);
  }
  getTodaysDate() {
    const today = new Date();
    let formattedDate = '';
    let date = '';
    let month = '';
    const dd = today.getDate();
    const mm = today.getMonth() + 1; // January is 0!

    const yyyy = today.getFullYear();
    if (dd < 10) {
      date = '0' + dd;
    } else {
      date = dd.toString();
    }
    if (mm < 10) {
      month = '0' + mm;
    } else {
      month = mm.toString();
    }
    formattedDate = date + '/' + month + '/' + yyyy;
    return formattedDate;
  }

  onLoginClick() {
    this.invokeLoginFunction.emit();
  }
  onLogoutClick() {

    this.invokeLogoutFunction.emit();

  }
  resumeQuote(quoteRefNo: string): Observable<any[]> {
    let quoteRef = { 'requestId': quoteRefNo, 'triggeredBy': 'DCJ' };
    if (this.router.url.includes('ho-underwriting')) {
      quoteRef = { 'requestId': quoteRefNo, 'triggeredBy': 'HOuser' };
    }

    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.resumeQuote).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }),
        filter(res => res['lock'] !== true)
      );

    } else {
      return this.http.post<any[]>(this.endPoints.resumeQuote, quoteRef, httpOptions).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
      );

    }
  }

  reQuote(quoteRefNo: string): Observable<any[]> {
    let quoteRef = { 'requestId': quoteRefNo };
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.reQuote);
    } else {
      return this.http.post<any[]>(this.endPoints.reQuote, quoteRef, httpOptions).
        map(res => {
          if (res && res['requote']) {
            this.requoteFlag = res['requote'];
          }
          return res;
        });
    }
  }
  triggerUnderwriting(isValidationRequired: boolean = true): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    this.getScreenName();
    this.processQuoteInformation(isValidationRequired, null);
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.saveQuoteDataCapture).map((res: Response) => {
        this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
        this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
        return res;
      });
    } else {
      return this.http.post<any>(this.endPoints.triggerUnderWriting, this.quoteDataCapture, httpOptions).
        map((res: Response) => {
          // this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
          // this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res));
          return res;
        }
        );
    }
  }

  fetchUIResponseJson(jsonUrlToFetch: string, reqPayload: ComponentAttributes): Observable<ComponentTypes> | Promise<ComponentTypes> | any {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<ComponentTypes>(jsonUrlToFetch);
    } else {
      return this.http.post<ComponentTypes>(jsonUrlToFetch, reqPayload, httpOptions);
    }
  }

  prepareReqPayloadCustomerScreen(): ComponentAttributes {
    let referenceDate: string;
    if (this.responseDataCapture) {
      referenceDate = this.responseDataCapture && this.responseDataCapture['quoteBasis'] && this.responseDataCapture['quoteBasis']['commencementDate'] ?
        this.responseDataCapture['quoteBasis']['commencementDate'] : this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    } else {
      referenceDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let referenceDateObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.referenceDate, referenceDate);
    let channelObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.channel, 'D');
    let journeyTypeObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.quoteJourneyType, 'DQE');
    let compObjCustomerScreen = new ComponentAttributes('DCJcedingPension', [channelObj, referenceDateObj, journeyTypeObj]);
    return compObjCustomerScreen;
  }

  prepareReqPayloadProductChoice(): ComponentAttributes {
    let referenceDate: string;
    if (this.responseDataCapture) {
      referenceDate = this.responseDataCapture && this.responseDataCapture['quoteBasis'] && this.responseDataCapture['quoteBasis']['commencementDate'] ?
        this.responseDataCapture['quoteBasis']['commencementDate'] : this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    } else {
      referenceDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let referenceDateObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.referenceDate, referenceDate);
    let selectedSource: string = this.productChoice && this.productChoice.source ? this.productChoice.source : '';
    let customerNeedObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.customerNeed, 'RT');
    let customerSourceObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.channelSource, 'D' + selectedSource);
    let compObjproductChoice = new ComponentAttributes('DCJproductOptions', [customerNeedObj, customerSourceObj, referenceDateObj]);
    return compObjproductChoice;
  }

  onSave(passthecontrol = '') {
    if (passthecontrol === '') {
      this.invokeSaveFunction.emit();
    } else {
      this.invokeSaveFunction.emit(true);
    }

  }

  getSelectedProduct(): string {
    if (this.productChoice) {
      return this.productChoice.selectedProduct;
    } else {
      return null;
    }
  }
  getSelectedDealPartner(): string {
    if (this.fundDetails) {
      return this.fundDetails.fundProvider;
    } else {
      return null;
    }
  }
  getProductAvailable(DealPartner: string = 'H') {
    let dob: string
    let ukaddressIndicator: string
    const commencementDate = this.getTodaysDate();
    if (!this.loginDetails) {
      dob = this.personDetail.dateOfBirth
      ukaddressIndicator = this.personDetail ? this.personDetail.ukaddressIndicator : ''
    } else {
      dob = this.loginDetails && this.loginDetails['customer'].dateOfBirth ? this.loginDetails['customer'].dateOfBirth : ''
      ukaddressIndicator = this.loginDetails ? this.loginDetails['customer'].ukaddressIndicator : ''
    }
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      // return this.http.get<any[]>(this.endPoints.ProductOptionsfromDealPartner);
      return Observable.of('C,H,G');

    } else {
      this.http.post<any>(this.endPoints.ProductOptionsfromDealPartner, { source: DealPartner, dateofbirth: dob, commDate: commencementDate, uKAddressIndicator: ukaddressIndicator }, httpOptions).subscribe(
        res => {
          return res;
          //return res['productOptions'].indexOf(selectedProduct)?Observable.of(true):Observable.of(false);
        });
    }
  }
  isCardCreatedforRefresh(refNumber: string): boolean {


    if (this.responseQuoteCalculation && this.responseQuoteCalculation['quoteRefNo'] === refNumber) {
      //console.log("benefit varient value", this.responseQuoteCalculation['benefitVariants']);
      if (this.responseQuoteCalculation['benefitVariants']) {
        if (this.responseQuoteCalculation['benefitVariants'].length >= 1) {
          return true;
        }
      }
    }
    else {
      return false;
    }

  }
  testcallforunderwriting(): Observable<any> {
    this.quoteDataCapture = this.quoteDataCaptureStructure();
    this.getScreenName();
    this.processQuoteInformation(false, null);

    return this.http.post<any>(this.endPoints.testApi, this.quoteDataCapture).map((res: Response) => {
      return res;
    });
  }

  getRefNum(): string {
    return this.quoteRefNo;
  }

  getFormSessionId(): string {
    return this.formSessionId;
  }
  searchPensionProvider(searchtext, introProvider) {
    return this.http.get<any>(this.endPoints.getPesionProviderList).pipe(
      map((res: any[]) => {
        if (res && res['Sheet1']) {
          res = res['Sheet1'].filter(provider => {
            return (provider.Introducer && provider.Introducer.toLowerCase() === 'n');
          }).filter(provider => {
            return provider.Name.toLowerCase().indexOf(searchtext.toLowerCase()) !== -1
          })
        }
        //  else {
        //   if (res && res['Sheet1']) {
        //     res = res['Sheet1'].filter(provider => {
        //       return provider.Name.toLowerCase().indexOf(searchtext.toLowerCase()) !== -1
        //     })
        //   }
        // }
        return res;
      })
    );
  }
  // searchPensionProviderByIntro(intro) {
  public searchPensionProviderByIntro(intro): Observable<any> {
    return this.http.get<any>(this.endPoints.getPesionProviderList).pipe(
      map((res: any[]) => {
        if (res && res['Sheet1']) {
          res = res['Sheet1'].filter(provider => {
            return (provider.Introducer && provider.Introducer.toLowerCase() === intro.toLowerCase());
          })
        }
        return res;
      })
    );
  }
  public GetRefnumberEncrypted(refnumber: string): Observable<any> {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return Observable.of(refnumber);

    } else {
      return this.http.post<any>(this.endPoints.getEncryptedReference, { quoteReference: refnumber }, httpOptions).
        map((res: Response) => {
          return res;
        });
    }
  }
  public GetFormSessionIdEncrypted(formSession_Id: string): Observable<any> {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return Observable.of(formSession_Id);

    } else {
      return this.http.post<any>(this.endPoints.sessionIdEncryption, { formSessionId: formSession_Id }, httpOptions).
        map((res: Response) => {
          return res;
        });
    }
  }
 
}
